// extracted by mini-css-extract-plugin
module.exports = {"container":"container___tmels","form":"form___33GJp","avatarContainer":"avatarContainer___ZoDCy","avatar":"avatar___nRADX","avatarDescription":"avatarDescription___3IFcK"};